import React from 'react';
import { useTranslation } from 'react-i18next';
import { TopBar } from '@weezevent/nacre';
import { useAuth } from 'react-oidc-context';

export default function Account() {
    const { t } = useTranslation();
    const auth = useAuth();
    const profile = auth.user.profile;
    const name = profile.name || `${profile.data?.firstname} ${profile.data?.name}`;

    return (
        <TopBar.Account
            tooltipTitle={t('sauron.top_bar.account')}
            content={name}
            items={[
                <TopBar.Account.Item
                    key="account"
                    title={name}
                    subtitle={t('sauron.top_bar.account')}
                    primary={{
                        component: 'a',
                        href: `${auth.settings.authority}/account`,
                        target: '_blank',
                        label: t('sauron.top_bar.manage_profil')
                    }}
                    mail={profile.email || profile.data?.email}
                    secondary={{
                        onClick: () => {
                            auth.removeUser();
                            auth.signoutRedirect({
                                post_logout_redirect_uri: `${window.location.origin}/`
                            });
                        },
                        label: t('sauron.top_bar.logout')
                    }}
                />
            ]}
        />
    );
}
